import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { Transition, useStyles } from './styles';

const LeadsDetails = ({ openDetails, onCloseDetails, details }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={openDetails}
      onClose={onCloseDetails}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogContent style={{ display: 'flex', flexWrap: 'wrap' }}>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Nombre Completo</Typography>
          <Typography className={classes.subTitles}>{details.nombre_completo}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Correo Electrónico</Typography>
          <Typography className={classes.subTitles}>{details.correo_electronico}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Teléfono</Typography>
          <Typography className={classes.subTitles}>
            {details.telefono}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Documento</Typography>
          <Typography className={classes.subTitles}>
            {details.tipo_documento}
            :
            {details.documento}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Departamento</Typography>
          <Typography className={classes.subTitles}>{details.departamento}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Ciudad</Typography>
          <Typography className={classes.subTitles}>{details.ciudad}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Marca</Typography>
          <Typography className={classes.subTitles}>{details.marca}</Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Linea</Typography>
          <Typography className={classes.subTitles}>{details.vehiculo}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Periodo Compra</Typography>
          <Typography className={classes.subTitles}>
            {details.periodo_compra}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Pago</Typography>
          <Typography className={classes.subTitles}>
            {details.pago}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Campaña</Typography>
          <Typography className={classes.subTitles}>
            {details.campana}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Fuente</Typography>
          <Typography className={classes.subTitles}>
            {details.fuente}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Origen</Typography>
          <Typography className={classes.subTitles}>{details.origen}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Integrado</Typography>
          <Typography className={classes.subTitles}>
            {details.integrado_impulsa === '1' ? 'Integrado' : 'No Integrado'}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Financiación</Typography>
          <Typography className={classes.subTitles}>
            {details.financiacion === '1' ? 'SI' : 'NO'}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Retoma</Typography>
          <Typography className={classes.subTitles}>
            {details.retoma === '1' ? 'SI' : 'NO'}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Test Drive</Typography>
          <Typography className={classes.subTitles}>
            {details.testdrive === '1' ? 'SI' : 'NO'}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Sitio Web</Typography>
          <Typography className={classes.subTitles}>
            {details.sitio_web === '1' ? 'SI' : 'NO'}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Habeas Data</Typography>
          <Typography className={classes.subTitles}>
            {details.habeas_data === '1' ? 'SI' : 'NO'}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Fecha Creación</Typography>
          <Typography className={classes.subTitles}>
            {details?.fecha_creacion?.slice(0, 10)}
          </Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Nombre Establecimiento</Typography>
          <Typography className={classes.subTitles}>{details.nombre_establecimiento}</Typography>
        </div>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Código destinatario</Typography>
          <Typography className={classes.subTitles}>{details.id_establecimiento}</Typography>
        </div>

      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseDetails} color="warning">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadsDetails;
